import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { toMomentString } from "config/util";
import { toNumber } from "config/util";
import { useDispatch, useSelector } from "react-redux";
import { initReactI18next, useTranslation } from "react-i18next";

const useStyles = makeStyles({
  table: {
    // minWidth: 650,
  },
});

export default function DenseTable({
  loading,
  rows,
  set_price,
  accounts,
  active_self,
  active_other
}) {
  // amount: "2"
  // ordered_at: "2021-03-15T03:05:52.000Z"
  // price: "546684.11300153"
  // type: 2
  const maps = useSelector((state) => state.reduce_get_maps);
  const [t, i18n] = useTranslation();

  const arr = [...Array(15)].map((_, i) => {
    if (rows && rows[i]) return rows[i];
    return { amount: "　" };
  });

  return (
    <TableContainer component={Paper}>
      <Table className="table-striped" size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell
              align="left"
              style={{ padding: 0, paddingLeft: 5, paddingRight: 5 }}
            >
              {t("時刻")}
            </TableCell>
            <TableCell
              align="right"
              style={{ padding: 0, paddingLeft: 5, paddingRight: 5 }}
            >
              <span style={{ color: "#4caf50" }}>{t("買い")}</span>
              <span style={{ color: "#f44336" }}>{t("売り")}</span>
              {t("価格")}
            </TableCell>
            <TableCell
              align="right"
              style={{ padding: 0, paddingLeft: 5, paddingRight: 5 }}
            >
              {t("数")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {arr.map((row, idx) => (
            <TableRow
              key={idx}
              onClick={() => {
                set_price(row.price);
              }}
            >
              <TableCell
                align="left"
                // style={{ paddingLeft: 5, paddingRight: 10 }}
                style={{ padding: 0, paddingLeft: 5, paddingRight: 5 }}
              >
                {toMomentString(row.ordered_at, "YY/MM/DD HH:mm")}
                {/* <i
                    className="material-icons"
                    style={{
                      display: "inline-block",
                      fontSize: 16,
                      width:16,
                      verticalAlign: "text-bottom",
                    }}
                  >
                    {row.user_id === accounts.user_id ? "account_circle":""}
                  </i> */}
              </TableCell>
              <TableCell
                align="right"
                style={{ padding: 0, paddingLeft: 5, paddingRight: 5 }}
                // style={{ paddingLeft: 10, paddingRight: 10 }}
              >
                <span style={{ color: row.type == 1 ? "#4caf50" : "#f44336" }}>
                  {toNumber(row.price, maps.coin_decimals[active_self].price)}
                </span>
              </TableCell>
              <TableCell
                align="right"
                style={{ padding: 0, paddingLeft: 5, paddingRight: 5 }}
                // style={{ paddingLeft: 10, paddingRight: 10 }}
              >
                {toNumber(row.amount, maps.coin_decimals[active_other].price)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
